import { useEffect, useMemo } from 'react';

import {
  checkMultipleScheduledCalls,
  getScheduledCallsBannerState,
} from 'common-src/models/PatientOncehubBooking';

const HEADER = '111px';
const HEADER_WITH_BANNER = '150px';

export const useScheduledCallsBanner = (scheduledCalls, timeZone, skipCheck) => {
  if (skipCheck) {
    return { showBanner: false, warningMessage: '' };
  }

  const { hasMultipleCallsAtSameTime, hasMultipleCallsOnSameDay } = checkMultipleScheduledCalls(
    scheduledCalls,
    timeZone,
  );

  const { showBanner, warningMessage } = useMemo(
    () => getScheduledCallsBannerState(hasMultipleCallsAtSameTime, hasMultipleCallsOnSameDay),
    [hasMultipleCallsAtSameTime, hasMultipleCallsOnSameDay],
  );

  useEffect(() => {
    const headerHeight = showBanner ? HEADER_WITH_BANNER : HEADER;
    document.documentElement.style.setProperty('--scheduled-calls-header', headerHeight);
  }, [showBanner]);

  return {
    showBanner,
    warningMessage,
  };
};
